import { useGetDiscountCodeOnMount } from '@user/store/discountCode/hooks/useGetDiscountCodeOnMount'
import { useMemo, ReactNode } from 'react'
import { useDialogState } from '@user/utils/useDialogState'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { ReferralDiscountDetailsDrawer } from '@user/components/DiscountCodes/Details/ReferralDiscountDetailsDrawer/ReferralDiscountDetailsDrawer'
import * as React from 'react'

interface Props {
  discountCodeId: string
  children?: ReactNode
}

export function TidalEntityDetailsDiscountCodeCardSmall(props: Props) {
  const { discountCodeId, children } = props

  const { discountCode, loadingStatus } =
    useGetDiscountCodeOnMount(discountCodeId)

  const typesCsv = useMemo(
    () =>
      discountCode?.discountLineItems
        .map((x) => `${x.referralType === 0 ? 'New' : 'Existing'} Customer`)
        .filter((value, index, self) => self.indexOf(value) === index)
        .sort()
        .join(', '),
    [discountCode?.discountLineItems],
  )

  const [open, onOpen, onClose] = useDialogState()

  if (loadingStatus === 'pending') {
    return <CircularProgress />
  }

  return (
    <Stack spacing={2}>
      {discountCode ? (
        <>
          <Box>
            <Typography variant="subtitle2">Discount</Typography>
            <Typography variant="body2">
              {discountCode.code} - {discountCode.name}
            </Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2">Types</Typography>
            <Typography variant="body2">{typesCsv}</Typography>
          </Box>
          <Box>
            <Typography variant="subtitle2">Details</Typography>
            <Typography variant="body2">{discountCode.description}</Typography>
          </Box>
          <ReferralDiscountDetailsDrawer
            onClose={onClose}
            open={open}
            referralDiscountCode={discountCode}
          />
        </>
      ) : (
        <Stack mb={2}>
          <Typography variant="subtitle2">Discount</Typography>
          <Typography variant="body2">No discount code added</Typography>
        </Stack>
      )}

      {children}
      {discountCode && (
        <Button sx={{ width: 'fit-content' }} variant="text" onClick={onOpen}>
          View Full Details
        </Button>
      )}
    </Stack>
  )
}
